export default __webpack_public_path__ + "static/media/Blog10.339a202f.png";